<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('invoice.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="onCloseDrawer"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('homework.date') }}</label>
                <a-range-picker
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('homework.status') }}</label>
                <a-select
                  v-model="status"
                  style="width:100%"
                  @change="fetchData"
                >
                  <a-select-option :value="1">{{
                    $t('eschool.progressing')
                  }}</a-select-option>
                  <a-select-option :value="2">{{
                    $t('eschool.closed')
                  }}</a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'teacher_name'
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.homework_date }}</td>
            <td>{{ record.class_name }}</td>
            <td>{{ record.subject_name }}</td>
            <td>{{ record.remarks }}</td>
            <td>{{ record.submission_end_date }}</td>
            <td class="text-center">
              <a
                href="#"
                class="text-primary"
                v-tooltip="$t('view')"
                @click.prevent="onView(record)"
              >
                <i class="fas fa-eye"></i>
              </a>
              <a
                href="#"
                class="ml-2 text-info"
                v-tooltip="$t('homework.comment')"
                v-if="record.homework_status_id == 1"
                @click.prevent="onComment(record)"
              >
                <i class="far fa-comment-dots"></i>
              </a>
              <a
                href="#"
                class="ml-2 text-info"
                v-tooltip="$t('homework.submitAnswerSheet')"
                v-if="record.homework_status_id == 1"
                @click.prevent="onViewSubmit(record)"
              >
                <i
                  class="fas fa-lock"
                  v-if="isLock(record.student_homework[0])"
                ></i>
                <i class="fas fa-file-upload" v-else></i>
              </a>
              <a
                href="#"
                class="ml-2 text-primary"
                v-tooltip="$t('homework.privateComment')"
                v-if="
                  record.homework_status_id == 1 &&
                    record.student_homework.length > 0
                "
                @click.prevent="onPrivateComment(record)"
              >
                <i class="fas fa-envelope-open-text"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-modal
        v-if="view_homework"
        v-model="view_homework"
        :title="$t('view')"
        :footer="null"
        :zIndex="1020"
        width="500px"
        @cancel="closeModel"
      >
        <view-homework :resources="view_resources" />
      </a-modal>
      <a-modal
        v-if="submit_answer_sheet"
        v-model="submit_answer_sheet"
        :title="$t('homework.answer')"
        :footer="null"
        :zIndex="1020"
        :maskClosable="false"
        width="500px"
        @cancel="closeSubmitModal"
      >
        <submit-answer :resources="view_resources" @close="closeSubmitModal" />
      </a-modal>
      <a-modal
        v-if="view_private_comment"
        v-model="view_private_comment"
        :title="$t('homework.comment')"
        :maskClosable="false"
        :footer="null"
        :zIndex="1020"
        width="500px"
        @cancel="closeModalComment"
      >
        <private-comment :resources="view_resources" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
import ViewHomework from './component/view-homework'
import SubmitAnswer from './component/submit-answer-sheet'
import PrivateComment from './component/private-comment'

export default {
  name: 'studentHomework',
  components: {
    ViewHomework,
    SubmitAnswer,
    PrivateComment
  },
  data() {
    return {
      loading: false,
      view_homework: false,
      view_private_comment: false,
      submit_answer_sheet: false,
      visible: false,
      rangeDate: [moment().add(-7, 'Day'), moment()],
      view_resources: []
    }
  },
  computed: {
    ...mapState('eschool/studentHomework', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.eschool.studentHomework.search
      },
      set(newValue) {
        this.$store.commit('eschool/studentHomework/SET_SEARCH', newValue)
        this.$store.commit('eschool/studentHomework/RESET_CURRENT_PAGE')
      }
    },
    status: {
      get() {
        return this.$store.state.eschool.studentHomework.status
      },
      set(newValue) {
        this.$store.commit('eschool/studentHomework/SET_STATUS_VALUE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('homework.date') },
        { name: this.$t('homework.class') },
        { name: this.$t('homework.subject') },
        { name: this.$t('homework.remark') },
        { name: this.$t('homework.submissionEnddate') },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    },
    isLock: () => record => {
      if (record != undefined) {
        return record.is_accepted
      }
      return false
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch('eschool/studentHomework/fetch')
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'eschool/studentHomework/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'eschool/studentHomework/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    onComment(record) {
      this.$router.push({
        name: 'homework-comment-public',
        params: { id: record.homework_id }
      })
    },
    onView(record) {
      this.view_homework = true
      this.view_resources = record
    },
    onViewSubmit(record) {
      if (this.isLock(record.student_homework[0])) {
        this.$toasted.info('This homework temporary is locked by teacher.')
        return
      }
      this.submit_answer_sheet = true
      this.view_resources = record
    },
    onPrivateComment(record) {
      this.view_private_comment = true
      this.view_resources = record
    },
    closeModel() {
      this.view_homework = false
      this.view_resources = []
    },
    closeSubmitModal() {
      this.submit_answer_sheet = false
      this.view_resources = []
      this.fetchData()
    },
    closeModalComment() {
      this.view_private_comment = false
      this.view_resources = []
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
